var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ArtsApprovalService from "../services/ArtsApprovalService";
import { formatDate } from "../../App/utils/formatter";
import Title from "../../App/components/Title";
import Notification from "../../App/components/Notification";
import { handleServiceError } from "../../App/components/ErrorHandler";
import "../styles/ArtsApproval.css";
import "../styles/Arts.css";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Tooltip, Pagination, Select, MenuItem } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { ART_STATUS_UPDATED_MESSAGE } from "../../App/utils/windowMessaging";
function ArtsApproval() {
    var _a = useState([]), userArts = _a[0], setUserArts = _a[1];
    var _b = useState(), designers = _b[0], setDesigners = _b[1];
    var _c = useState("todos"), selectedDesignerId = _c[0], setSelectedDesignerId = _c[1];
    var _d = useState([]), status = _d[0], setStatus = _d[1];
    var _e = useState(""), selectStatus = _e[0], setSelectStatus = _e[1];
    var _f = useState(""), sortBy = _f[0], setSortBy = _f[1];
    var _g = useState(""), direction = _g[0], setDirection = _g[1];
    var _h = useState(""), userUploadedArt = _h[0], setUserUploadedArt = _h[1];
    var _j = useState(1), currentPage = _j[0], setCurrentPage = _j[1];
    var _k = useState(0), totalItems = _k[0], setTotalItems = _k[1];
    var _l = useState(20), perPage = _l[0], setPerPage = _l[1];
    var _m = useState(null), paginateData = _m[0], setPaginateData = _m[1];
    var _o = useState(false), isInputVisibleName = _o[0], setIsInputVisibleName = _o[1];
    var _p = useState(false), isInputVisibleNumber = _p[0], setIsInputVisibleNumber = _p[1];
    var _q = useState(false), refresh = _q[0], setRefresh = _q[1];
    var _r = useState(""), filterTicketNumber = _r[0], setFilterTicketNumber = _r[1];
    var location = useLocation();
    var _s = useState({ key: 'updated_at', direction: 'desc' }), sortConfig = _s[0], setSortConfig = _s[1];
    var _t = useState(""), searchName = _t[0], setSearchName = _t[1];
    var _u = useState(""), searchNumber = _u[0], setSearchNumber = _u[1];
    useEffect(function () {
        getAllTheArtsForTheDesigners({
            perPage: perPage,
            page: currentPage,
            status: selectStatus,
            designer: selectedDesignerId,
            userUploadedArt: userUploadedArt,
            sortBy: sortBy,
            direction: direction,
            filterTicketNumber: filterTicketNumber,
        });
        getAllDesigners();
        getAllStatus();
    }, [perPage, currentPage, selectStatus, selectedDesignerId, userUploadedArt, sortBy, direction, refresh, filterTicketNumber]);
    useEffect(function () {
        function handleArtUpdatedMessage(event) {
            var _a;
            if (event.origin !== window.location.origin) {
                return;
            }
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === ART_STATUS_UPDATED_MESSAGE) {
                updatePage();
            }
        }
        window.addEventListener("message", handleArtUpdatedMessage);
        return function () { return window.removeEventListener("message", handleArtUpdatedMessage); };
    }, []);
    function getAllTheArtsForTheDesigners(_a) {
        var perPage = _a.perPage, page = _a.page, status = _a.status, designer = _a.designer, userUploadedArt = _a.userUploadedArt, sortBy = _a.sortBy, direction = _a.direction, filterTicketNumber = _a.filterTicketNumber;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        Notification().Block.circle("[data-id=arts-grid]");
                        return [4 /*yield*/, ArtsApprovalService.getAllTheArtsForTheDesigners({
                                per_page: perPage,
                                page: page,
                                status: status,
                                designer: designer,
                                user_uploaded_art: userUploadedArt,
                                sortBy: sortBy,
                                direction: direction,
                                filter_ticket_number: filterTicketNumber,
                            })
                                .then(function (res) {
                                setUserArts(res.data.arts.data);
                                setPaginateData(res.data.arts);
                                setTotalItems(res.data.arts.total);
                                Notification().Block.remove("[data-id=arts-grid]");
                            }, function (err) {
                                Notification().Notify.failure("Erro ao buscar as artes");
                            })];
                    case 1:
                        _b.sent();
                        Notification().Block.remove("[data-id=arts-grid]");
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function getAllDesigners() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ArtsApprovalService.getAllDesigners()
                            .then(function (res) {
                            setDesigners(res.data.designers);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function getAllStatus() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ArtsApprovalService.getAllArtsStatus()
                            .then(function (res) {
                            setStatus(res.data.status);
                        }, function (err) {
                            handleServiceError(err);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function capitalizeFirstLetter(str) {
        return str.split(' ')
            .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
            .join(' ');
    }
    ;
    function handleConfirmChange(value, artId) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var userId, selectedDesigner, newUserName, currentArt, currentDesignerId, currentDesigner, currentDesignerName, message;
            return __generator(this, function (_b) {
                userId = Number(value);
                selectedDesigner = designers && Object.values(designers).find(function (d) { return String(d.id) === value; });
                newUserName = selectedDesigner ? selectedDesigner.name : "N/D";
                currentArt = userArts.find(function (art) { return art.id === artId; });
                currentDesignerId = (_a = currentArt === null || currentArt === void 0 ? void 0 : currentArt.designer) === null || _a === void 0 ? void 0 : _a.id;
                currentDesigner = designers && currentDesignerId
                    ? Object.values(designers).find(function (d) { return d.id === currentDesignerId; })
                    : null;
                currentDesignerName = currentDesigner
                    ? capitalizeFirstLetter(currentDesigner.name)
                    : "N/D";
                message = currentDesignerName !== "N/D"
                    ? "Essa tarefa est\u00E1 com o Designer ".concat(currentDesignerName, ". Deseja mesmo alterar para ").concat(capitalizeFirstLetter(newUserName), "?")
                    : "Deseja atribuir essa tarefa ao Designer ".concat(capitalizeFirstLetter(newUserName), "?");
                Notification().Confirm.show("Alterar designer", message, "Cancelar", "Confirmar", function () { }, function () {
                    handleChange(userId, artId);
                }, {
                    okButtonBackground: "#ccc",
                    cancelButtonBackground: "#F44336"
                });
                return [2 /*return*/];
            });
        });
    }
    function handleChange(userId, artId) {
        return __awaiter(this, void 0, void 0, function () {
            var isUnassigned_1, newStatusId_1, newStatus_1, updatedArts, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Notification().Block.circle("[data-id=arts-grid]");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ArtsApprovalService.storeDesigner({
                                user_id: Number(userId),
                                art_id: artId
                            })];
                    case 2:
                        _a.sent();
                        Notification().Notify.success("Designer atualizado com sucesso!");
                        isUnassigned_1 = Number.isNaN(Number(userId));
                        newStatusId_1 = isUnassigned_1 ? 1 : 2;
                        newStatus_1 = status.find(function (s) { return s.id === newStatusId_1; });
                        updatedArts = userArts === null || userArts === void 0 ? void 0 : userArts.map(function (art) {
                            var _a, _b;
                            return art.id === artId
                                ? __assign(__assign({}, art), { designer: isUnassigned_1 ? undefined : __assign(__assign({}, art.designer), { id: userId }), status_id: newStatusId_1, color: (_a = newStatus_1 === null || newStatus_1 === void 0 ? void 0 : newStatus_1.color) !== null && _a !== void 0 ? _a : art.color, art_status_translation: (_b = newStatus_1 === null || newStatus_1 === void 0 ? void 0 : newStatus_1.art_status_translation) !== null && _b !== void 0 ? _b : art.art_status_translation }) : art;
                        });
                        setUserArts(updatedArts);
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        Notification().Notify.failure(error_1.response.data.error);
                        return [3 /*break*/, 5];
                    case 4:
                        Notification().Block.remove("[data-id=arts-grid]");
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    ;
    var handleSortAction = function (key) {
        setSortConfig(function (prevConfig) {
            if (prevConfig.key === key) {
                return {
                    key: key,
                    direction: prevConfig.direction === 'asc' ? 'desc' : 'asc'
                };
            }
            return {
                key: key,
                direction: 'desc'
            };
        });
        if (sortBy === key) {
            setDirection(direction === 'asc' ? 'desc' : 'asc');
        }
        else {
            setSortBy(key);
            setDirection('asc');
        }
    };
    var getSortIcon = function (key) {
        if (sortConfig.key !== key) {
            return _jsx(ArrowDownwardIcon, { className: "sort-created-at-icon" });
        }
        return sortConfig.direction === 'asc'
            ? _jsx(ArrowUpwardIcon, { className: "sort-created-at-icon active" })
            : _jsx(ArrowDownwardIcon, { className: "sort-created-at-icon active" });
    };
    var handleTicketHistoryClick = function (art) {
        var _a;
        var designerName = ((_a = art.designer) === null || _a === void 0 ? void 0 : _a.name)
            ? capitalizeFirstLetter(art.designer.name)
            : null;
        var newWindow = window.open("/ticket_history/".concat(art.id), '_blank');
        if (newWindow) {
            newWindow.onload = function () {
                newWindow.postMessage({
                    type: 'INITIAL_DATA',
                    data: {
                        referer: location.pathname,
                        designerName: designerName,
                    }
                }, window.location.origin);
            };
        }
    };
    var handleSearchName = function (value) {
        setSearchName(value);
        if (value === "") {
            setUserUploadedArt("");
        }
        else {
            setUserUploadedArt(value);
        }
    };
    var handleSearchNumber = function (value) {
        setSearchNumber(value);
        if (value === "") {
            setFilterTicketNumber("");
        }
        else {
            setFilterTicketNumber(value);
        }
    };
    function handleKeyUp(e, type) {
        var value = e.currentTarget.value.trim();
        if (type === 'number') {
            var numbersOnly = value.replace(/\D/g, '');
            if (value !== numbersOnly) {
                e.currentTarget.value = numbersOnly;
                value = numbersOnly;
            }
        }
        if (e.key !== "Enter" && e.key !== "Escape") {
            return;
        }
        if (type === 'name') {
            if (e.key === "Escape") {
                e.currentTarget.value = "";
                handleSearchName("");
                setIsInputVisibleName(false);
            }
            else {
                handleSearchName(value);
            }
        }
        else if (type === 'number') {
            if (e.key === "Escape") {
                e.currentTarget.value = "";
                handleSearchNumber("");
                setIsInputVisibleNumber(false);
            }
            else {
                handleSearchNumber(value);
            }
        }
    }
    ;
    function handleIconClickName() {
        setIsInputVisibleName(function (prevState) { return !prevState; });
        setIsInputVisibleNumber(false);
        if (!isInputVisibleName) {
            setTimeout(function () {
                var input = document.querySelector('input[data-type="name"]');
                if (input)
                    input.focus();
            }, 100);
        }
        else if (searchName === "") {
            setUserUploadedArt("");
        }
    }
    ;
    function handleIconClickNumber() {
        setIsInputVisibleNumber(function (prevState) { return !prevState; });
        setIsInputVisibleName(false);
        if (!isInputVisibleNumber) {
            setTimeout(function () {
                var input = document.querySelector('input[data-type="number"]');
                if (input)
                    input.focus();
            }, 100);
        }
        else if (searchNumber === "") {
            setFilterTicketNumber("");
        }
    }
    ;
    function cleanFilter() {
        setPerPage(20);
        setSelectStatus("");
        setSelectedDesignerId("todos");
        setUserUploadedArt("");
        setSortBy("");
        setDirection("asc");
        setFilterTicketNumber('');
        setSearchName("");
        setSearchNumber("");
        setIsInputVisibleName(false);
        setIsInputVisibleNumber(false);
        var nameInput = document.querySelector('input[data-type="name"]');
        var numberInput = document.querySelector('input[data-type="number"]');
        if (nameInput)
            nameInput.value = "";
        if (numberInput)
            numberInput.value = "";
        getAllTheArtsForTheDesigners({
            perPage: 20,
            page: 1,
            status: "",
            designer: "todos",
            userUploadedArt: "",
            sortBy: "",
            direction: "asc",
            filterTicketNumber: "",
        });
        updatePage();
    }
    ;
    var handlePageChange = function (event, value) {
        if (value > Math.ceil(totalItems / perPage)) {
            return;
        }
        setCurrentPage(value);
    };
    function updatePage() {
        setRefresh(function (prev) { return !prev; });
    }
    ;
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsx(Title, { text: "Aprova\u00E7\u00E3o de artes", hr: true }), _jsx("div", {}), _jsxs("table", __assign({ className: "table-arts", "data-id": "arts-grid" }, { children: [_jsxs("tr", __assign({ style: { height: '80px' } }, { children: [_jsx("th", { children: _jsxs("div", __assign({ className: "search-provider-uploaded-art" }, { children: [_jsxs("button", __assign({ type: "button", onClick: handleIconClickNumber, style: { background: "none", border: "none", fontWeight: "bold", marginLeft: '1.5rem' } }, { children: ["N\u00FAmero  ", " ", _jsx(SearchIcon, { className: "search-providers-icon" })] })), isInputVisibleNumber && (_jsx("input", { type: "text", placeholder: "Digite o n\u00FAmero", value: searchNumber, onChange: function (e) {
                                                var numbersOnly = e.target.value.replace(/\D/g, '');
                                                setSearchNumber(numbersOnly);
                                            }, onKeyUp: function (e) { return handleKeyUp(e, 'number'); }, className: "visible", "data-type": "number", autoComplete: "off", style: { textAlign: 'center' } }))] })) }), _jsx("th", { children: _jsxs("div", __assign({ className: "search-provider-uploaded-art" }, { children: [_jsxs("button", __assign({ type: "button", onClick: handleIconClickName, style: { background: "none", border: "none", fontWeight: "bold" } }, { children: ["Nome ", " ", _jsx(SearchIcon, { className: "search-providers-icon" })] })), isInputVisibleName && (_jsx("input", { type: "text", placeholder: "Digite o nome", value: searchName, onChange: function (e) { return setSearchName(e.target.value); }, onKeyUp: function (e) { return handleKeyUp(e, 'name'); }, className: "visible", "data-type": "name", autoComplete: "off", style: { textAlign: 'center' } }))] })) }), _jsx("th", { children: _jsxs(Select, __assign({ value: selectedDesignerId !== null && selectedDesignerId !== void 0 ? selectedDesignerId : "n/d", onChange: function (e) {
                                        if (e.target.value === "n/d") {
                                            setSelectedDesignerId('n/d');
                                        }
                                        else if (e.target.value === "todos") {
                                            setSelectedDesignerId("todos");
                                        }
                                        else {
                                            setSelectedDesignerId(e.target.value);
                                        }
                                    }, variant: "standard", disableUnderline: true, className: "table-arts-select", sx: { fontWeight: "bold", fontSize: 14 } }, { children: [_jsx(MenuItem, __assign({ value: "todos" }, { children: "Todos" })), _jsx(MenuItem, __assign({ value: "n/d" }, { children: "N/D" })), designers && Object.values(designers).map(function (designer) { return (_jsx(MenuItem, __assign({ value: String(designer.id) }, { children: capitalizeFirstLetter(designer.name) }), "".concat(designer.id, "_designer"))); })] })) }), _jsxs("th", __assign({ onClick: function () { return handleSortAction("updated_at"); } }, { children: ["Atualizado em ", " ", " ", getSortIcon("updated_at")] })), _jsx("th", { children: _jsxs("div", __assign({ style: { display: "flex", alignItems: "center", justifyContent: "center", gap: "24px" } }, { children: [_jsxs(Select, __assign({ value: selectStatus, onChange: function (e) { return setSelectStatus(e.target.value); }, displayEmpty: true, variant: "standard", disableUnderline: true, className: "table-arts-select", sx: { fontWeight: "bold", fontSize: 14 } }, { children: [_jsx(MenuItem, __assign({ value: "" }, { children: "Todos os status" })), status.length > 0 ? (status.map(function (item) { return (_jsx(MenuItem, __assign({ value: String(item.id) }, { children: item.art_status_translation }), item.id)); })) : (_jsx(MenuItem, __assign({ disabled: true }, { children: "Nenhum status cadastrado" })))] })), _jsx("button", __assign({ type: "button", id: "button-addon2", className: "button-clear-arts-approval", style: { border: "transparent", color: "rgb(167, 167, 167)", background: "#fff" }, onClick: function () { return cleanFilter(); } }, { children: _jsx(FilterAltOffIcon, { style: { color: "#A7A7A7" } }) }))] })) })] })), userArts && Object.values(userArts).map(function (art) {
                        var _a;
                        var prod_url = process.env.REACT_APP_STORAGE_URL;
                        return (_jsxs("tr", __assign({ onClick: function () { return handleTicketHistoryClick(art); }, style: { cursor: "pointer" } }, { children: [_jsxs("td", { children: ["#", art.id] }), _jsx(Tooltip, __assign({ title: art.customer_name, placement: "top", arrow: true }, { children: _jsx("td", __assign({ className: "td-custom" }, { children: art.customer_name })) })), _jsx("td", __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: _jsxs(Select, __assign({ value: ((_a = art.designer) === null || _a === void 0 ? void 0 : _a.id) != null ? String(art.designer.id) : "N/D", onChange: function (e) { handleConfirmChange(e.target.value, art.id); }, disabled: [4, 5, 6, 7].includes(art.status_id), variant: "standard", disableUnderline: true, className: "select-designer-arts-approval" }, { children: [_jsx(MenuItem, __assign({ value: "N/D" }, { children: "N/D" })), designers && Object.values(designers).map(function (designer) { return (_jsx(MenuItem, __assign({ value: String(designer.id) }, { children: capitalizeFirstLetter(designer.name) }), "".concat(designer.id, "_designer"))); })] })) })), _jsx("td", { children: formatDate(art.updated_at) }), _jsx("td", __assign({ style: { display: "flex", justifyContent: "center", padding: "23.5px" } }, { children: _jsx("div", __assign({ className: "status-button", style: { backgroundColor: art.color, color: art.color !== "#00000014" ? "#000" : "inherit" } }, { children: art.art_status_translation })) }))] }), art.id));
                    })] })), paginateData && (_jsx("div", __assign({ style: { display: "flex", justifyContent: "flex-end", paddingTop: "1rem" } }, { children: _jsx(Pagination, { count: Math.ceil(totalItems / perPage), page: currentPage, onChange: handlePageChange, color: "primary", showFirstButton: true, showLastButton: true }) })))] })));
}
export default ArtsApproval;
